<div [formGroup]="form">
  <div class="w-[100%] flex justify-end mb-[5px]">
    <div class="flex justify-start">
      <div
        class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[50%] flex justify-end items-center"
      >
        <img
          src="assets/icons/close.svg"
          alt="close"
          class="cursor-pointer w-[14px]"
          (click)="cancel()"
        />
      </div>
      <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[50%]">
        <img
          src="assets/icons/save.svg"
          alt="save"
          class="cursor-pointer w-[20px] pr-[2px]"
          (click)="save()"
        />
      </div>
    </div>
  </div>

  <mat-form-field *ngIf="!isCurrencyField" appearance="outline">
    <mat-label>{{ title }}</mat-label>
    <input
      matInput
      [placeholder]="placeholder"
      [value]="value"
      id="name"
      formControlName="name"
    />
    <mat-error *ngIf="form.get('name')?.hasError('required')">
      {{ title }} is required</mat-error
    >
  </mat-form-field>

  <mat-form-field *ngIf="isCurrencyField" appearance="outline">
    <mat-label>{{ title }}</mat-label>
    <input
      maxlength="12"
      matInput
      [placeholder]="placeholder"
      [value]="value"
      id="name"
      formControlName="name"
      currencyMask
      [options]="{
        prefix: country?.symbol ? country?.symbol : '',
        thousands: ',',
        decimal: '',
        precision: 0
      }"
    />
    <mat-error *ngIf="form.get('name')?.hasError('required')">
      {{ title }} is required</mat-error
    >
  </mat-form-field>
</div>
